import { LoginService } from "../login/login.service";
import { Directive, forwardRef } from "@angular/core";
import { NG_ASYNC_VALIDATORS, Validator, AbstractControl } from "@angular/forms";
import { Observable } from "rxjs";
@Directive({
    selector: "[validateUsuario][formControlName], [validateUsuario][ngModel], [validateUsuario][formControl]",
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef(() => ValidateUsuario), multi: true
        }
    ]
})
export class ValidateUsuario implements Validator {
    constructor(private loginService: LoginService) { }

    validate(c: AbstractControl): Observable<{ [key: string]: any }> {
        return this.validateUniqueUserObservable(c.value).debounceTime(500).distinctUntilChanged().first(); ;
    }

    validateUniqueUserObservable(usuario: string) {
        return new Observable(observer => {
            let bandera = false;
            this.loginService.verificarUsuario(usuario).subscribe(result => {
                if (result == true) {
                    observer.next({ ValidateUsuario: false });
                } else {
                    observer.next(null);
                }
            },
                error => observer.next({ ValidateUsuario: false }));
        });
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/register/verificarUsuario.directive.ts